<template>
  <div class="everyday">
    <a-list
      class="demo-loadmore-list"
      :loading="loading"
      item-layout="horizontal"
      :data-source="data"
    >
      <div
        v-if="showLoadingMore"
        slot="loadMore"
        :style="{
          textAlign: 'center',
          marginTop: '12px',
          height: '32px',
          lineHeight: '32px',
        }"
      >
        <a-spin v-if="loadingMore" />
        <a-button v-else @click="onLoadMore"> 加载更多 </a-button>
      </div>
      <a-list-item slot="renderItem" slot-scope="item">
        <a slot="actions" @click="adoptChong(item.dynamicCode, 2)">查看</a>
        <a slot="actions" @click="adoptChong(item.dynamicCode, 0)">删除</a>
        <a-list-item-meta :description="item.dynamicDescribe">
          <a slot="title" @click="toNucleus(item.dynamicUrl)">{{
            item.dynamicMake
          }}</a>
          <!-- <a-avatar slot="avatar" :src="item.userImageurl" /> -->
        </a-list-item-meta>
        <div>{{ item.typeName }}</div>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  name: "everyday",
  data() {
    return {
      everyday: "每日",

      loading: true,
      loadingMore: false,
      showLoadingMore: true,
      data: [],

      init: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getData((res) => {
      this.data = res.results;
    });
  },

  methods: {
    getData() {
      this.$get("/vr/netuser/dynamic/query", this.init)
        .then((response) => {
          this.data = response.data;
          this.loading = false;
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
          console.log(error);
        });
    },

    onLoadMore() {
      this.loadingMore = true;
      this.init.pageNum += 1;
      this.$get("/vr/netuser/dynamic/query", this.init)
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.data = this.data.concat(response.data);
          this.loadingMore = false;
          this.$nextTick(() => {
            window.dispatchEvent(new Event("resize"));
          });
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
          console.log(error);
        });
      // this.getData(() => {
      //   this.data = this.data.concat(res.results);
      //   this.loadingMore = false;
      //   this.$nextTick(() => {
      //     window.dispatchEvent(new Event("resize"));
      //   });
      // });
    },
    adoptChong(id, adopt) {
      this.$post("/vr/netuser/dynamic/adopt", {
        // dynamiccode: id,
        // adopt: adopt,
      })
        .then((response) => {
          if (response.code != 1) {
            this.$message.error("服务器繁忙", 5);
          }
          this.$message.success("审核通过！");
          this.getData();
        })
        .catch((error) => {
          this.$message.error(error.data, 5);
        });
    },
    toNucleus(data) {
      let url = this.$Encrypt(data);
      this.$router.push({
        name: "nucleusday",
        query: {
          message: url,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.everyday {
  min-height: 300px;
  padding: 0px 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/user/usercolumn/release/telegraphs/everyday.vue